import { Divider, Grid, Skeleton, SxProps, Typography } from '@mui/material'
import { Edit } from 'react-feather'
import React, { useCallback, useEffect } from 'react'
import { useTheme } from '@mui/material/styles'
import ConfirmationDialog from '../../../../components/ConfirmationDialog/ConfirmationDialog'
import { Trans } from 'react-i18next'
import InputTextField from '../../../../components/InputTextField/InputTextField'
import { dialogTitleStyle, editIcon } from './EditCampaignName.styles'
import { actionUpdateCampaignDetails } from '../../../../store/slices/campaign/campaignSlice'
import { useAppDispatch } from '../../../../store/utils/hooks'

type EditCampaignNameProps = {
	campaign: any
	sx?: SxProps
}

export default function EditCampaignName({ campaign, sx }: EditCampaignNameProps) {
	const { palette } = useTheme()
	const dispatch = useAppDispatch()
	const [open, setOpen] = React.useState(false)
	const [newCampaignName, setNewCampaignName] = React.useState('')

	const handleCampaignNameChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
		setNewCampaignName(e.target.value)
	}, [])

	const handleNewCampaignName = useCallback(async () => {
		if (newCampaignName !== campaign.campaign_name) {
			dispatch(
				actionUpdateCampaignDetails({
					campaignId: campaign.campaign_id,
					updates: { campaignName: newCampaignName },
				}),
			)
		}
		setOpen(false)
	}, [campaign, dispatch, newCampaignName])

	const handleClose = useCallback(() => {
		setNewCampaignName(campaign.campaign_name)
		setOpen(false)
	}, [campaign?.campaign_name])

	useEffect(() => {
		setNewCampaignName(campaign?.campaign_name)
	}, [campaign?.campaign_name])

	return (
		<>
			{campaign?.campaign_name ? (
				<>
					<Typography sx={sx}>{campaign?.campaign_name}</Typography>
					<Edit onClick={() => setOpen(true)} style={editIcon(palette)} />
				</>
			) : (
				<Skeleton sx={{ width: '25%' }} />
			)}

			<ConfirmationDialog
				open={open}
				onClose={handleClose}
				action={handleNewCampaignName}
				acceptDisabled={newCampaignName === campaign?.campaign_name}
			>
				<Typography variant="h5" color={palette.text.primary} textAlign="left" sx={dialogTitleStyle}>
					<Trans i18nKey="campaign_details.edit_campaign_name_modal_title" />
				</Typography>
				<Divider sx={{ mb: 2 }} />
				<form onSubmit={() => {}}>
					<Grid container xs={12} md={12} spacing={2} mb="40px">
						<Grid item xs={12} md={12}>
							<InputTextField
								required
								i18nLabel="campaign_details.edit_campaign_name_modal_field_label"
								type="text"
								name="campaignName"
								value={newCampaignName}
								onChange={handleCampaignNameChange}
							/>
						</Grid>
					</Grid>
				</form>
			</ConfirmationDialog>
		</>
	)
}
